import React, { useEffect, useState, useReducer } from 'react';
import { Form, Button, Tab } from 'semantic-ui-react';
import request from 'services/http';
import { map, tap, finalize } from 'rxjs/operators';
import FormPeriodo from 'components/FormPeriodo';
import { forkJoin } from 'rxjs';
import produce from 'immer';
import { paramsToSearchURL } from 'utils';
import { DateTime, Interval } from 'luxon';
import { withRouter } from 'react-router-dom';
import ReactInputMask from 'react-input-mask';

const filterInitialValues = {
    companyGrouped: {
        companyId: 'all',
        period: [],
        paymentType: '',
    },
    companyDetailed: {
        companyId: '',
        period: [],
        paymentType: '',
    },
    customer: {
        year: '',
        paymentType: '',
        cutDate: '31/12/2019',
    },
};

function filterReducer(state, action) {
    if (action.action === 'reset') {
        return produce(state, (draft) => {
            draft[action.filterType] = filterInitialValues[action.filterType];
        });
    }
    return produce(state, (draft) => {
        draft[action.filterType][action.field] = action.value;
    });
}

function Filters(props) {
    const [unidades, setUnidades] = useState([]);
    const [paymentTypes, setPaymentTypes] = useState([]);
    const [activeIndex, setActiveIndex] = useState(0);

    const [filterState, setFilterState] = useReducer(filterReducer, filterInitialValues);

    useEffect(() => {
        if (props.onFilterChange) {
            props.onFilterChange(filterState);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [filterState]);

    useEffect(() => {
        setActiveIndex();
    }, [props.setTab]);

    useEffect(() => {
        const reqUnidades = request({ method: 'GET', url: '/recebiveis/em-aberto/companies' }).pipe(
            map(({ response }) => response),
        );
        const reqTipoRecebiveis = request({
            method: 'GET',
            url: '/recebiveis/em-aberto/payment-types',
        }).pipe(map(({ response }) => response));

        const sub = forkJoin([reqUnidades, reqTipoRecebiveis])
            .pipe(
                tap((data) => {
                    setUnidades(data[0]);
                    setPaymentTypes(data[1]);
                }),
                finalize(() => sub.unsubscribe()),
            )
            .subscribe();
    }, []);

    function fieldChange(filterType) {
        return (ev, data) => {
            const field = ev?.target?.name || data?.name || '';
            const value = ev?.target?.value || data?.value || '';
            setFilterState({ filterType, field, value });
        };
    }

    function getYears() {
        return Interval.fromDateTimes(
            DateTime.fromISO('2011-01-01'),
            DateTime.fromISO('2019-12-31'),
        )
        .splitBy({ year: 1 })
        .map((it) => it.start.year);
    }

    function submit(filterType) {
        return () => {
            props.onLoading(filterType, true);
            let params = { filter: filterType };
            const filters = filterState[filterType];
            for (let param in filters) {
                switch (param) {
                    case 'period':
                        params[param] = filters[param]
                            .map((it) => DateTime.fromJSDate(it).toISODate())
                            .join();
                        break;

                    default:
                        params[param] = filters[param];
                }
            }
            props.onSearch(filterType, params);

            const req = request({
                method: 'GET',
                url: `/recebiveis/em-aberto/data?${paramsToSearchURL(params, false)}`,
            })
                .pipe(
                    tap(({ response }) => {
                        props.onData(response || [], filterType);
                    }),
                    finalize(() => {
                        req.unsubscribe();
                        props.onLoading(filterType, false);
                    }),
                )
                .subscribe();
        };
    }

    function clear(filterType) {
        return () => {
            setFilterState({ action: 'reset', filterType });
            return props.onClear(filterType);
        }
    }

    function tabChange(data) {
        setActiveIndex(data.activeIndex);
        const filter = data.panes[data.activeIndex].menuItem.key;
        // const search = new URLSearchParams(window.location.search);
        // if (search.has('filter')) {
        //     for (let p in data.panes) {
        //         console.log(data.panes[p]);
        //         if (data.panes[p].menuItem.key == search.get('filter')) {
        //             console.log(Number(p));
        //             setActiveIndex(Number(p));
        //             return props.onTabChange(search.get('filter'));
        //         }
        //     }
        // }
        return props.onTabChange(filter);
        // const params = new URLSearchParams(props.location.search);
        // params.set('filter', filter);
        // history.push({ search: `?${decodeURIComponent(params.toString())}` });
    }

    return (
        <div id="recebiveis-em-aberto-filter">
            <Tab
                renderActiveOnly={false}
                activeIndex={activeIndex}
                onTabChange={(_, data) => tabChange(data)}
                panes={[
                    {
                        menuItem: {
                            key: 'companyGrouped',
                            content: 'Unidade | agrupado',
                            icon: 'building outline',
                        },
                        pane: (
                            <Tab.Pane key="companyGrouped">
                                <Form>
                                    <Form.Group>
                                        <FormPeriodo
                                            label="Emissão da Venda / Data de corte"
                                            value={filterState.companyGrouped.period}
                                            required
                                            name="period"
                                            onChange={fieldChange('companyGrouped')}
                                        />

                                        <Form.Select
                                            search
                                            width={3}
                                            required
                                            name="paymentType"
                                            label="Tipo de Recebível"
                                            onChange={fieldChange('companyGrouped')}
                                            value={filterState.companyGrouped.paymentType}
                                            selectOnBlur={false}
                                            options={paymentTypes.map((it) => ({
                                                key: it.name,
                                                value: it.name,
                                                text: it.text,
                                            }))}
                                        />

                                        <Form.Field>
                                            <label>&nbsp;</label>
                                            <Button
                                                primary
                                                icon="cogs"
                                                content="Gerar"
                                                onClick={submit('companyGrouped')}
                                            />
                                        </Form.Field>
                                        <Form.Field className='pl-0'>
                                            <label>&nbsp;</label>
                                            <Button
                                                color='yellow'
                                                icon="erase"
                                                content="Limpar"
                                                onClick={clear('companyGrouped')}
                                            />
                                        </Form.Field>
                                    </Form.Group>
                                </Form>
                            </Tab.Pane>
                        ),
                    },
                    {
                        menuItem: {
                            key: 'companyDetailed',
                            content: 'Unidade | detalhado',
                            icon: 'building outline',
                        },
                        pane: (
                            <Tab.Pane key="companyDetailed">
                                <Form>
                                    <Form.Group>
                                        <Form.Select
                                            search
                                            width="3"
                                            label="Unidade"
                                            name="companyId"
                                            onChange={fieldChange('companyDetailed')}
                                            value={filterState.companyDetailed.companyId}
                                            selectOnBlur={false}
                                            options={unidades.map((it) => ({
                                                key: it.id,
                                                value: it.id,
                                                text: it.unidade_nome,
                                            }))}
                                        />

                                        <FormPeriodo
                                            label="Emissão da Venda / Data de corte"
                                            value={filterState.companyDetailed.period}
                                            name="period"
                                            onChange={fieldChange('companyDetailed')}
                                        />

                                        <Form.Select
                                            search
                                            width={3}
                                            required
                                            name="paymentType"
                                            label="Tipo de Recebível"
                                            onChange={fieldChange('companyDetailed')}
                                            value={filterState.companyDetailed.paymentType}
                                            selectOnBlur={false}
                                            options={paymentTypes.map((it) => ({
                                                key: it.name,
                                                value: it.name,
                                                text: it.text,
                                            }))}
                                        />

                                        <Form.Field>
                                            <label>&nbsp;</label>
                                            <Button
                                                primary
                                                icon="cogs"
                                                content="Gerar"
                                                onClick={submit('companyDetailed')}
                                            />
                                        </Form.Field>
                                        <Form.Field className='pl-0'>
                                            <label>&nbsp;</label>
                                            <Button
                                                color='yellow'
                                                icon="erase"
                                                content="Limpar"
                                                onClick={clear('companyDetailed')}
                                            />
                                        </Form.Field>
                                    </Form.Group>
                                </Form>
                            </Tab.Pane>
                        ),
                    },
                    {
                        menuItem: {
                            key: 'customer',
                            content: 'Cliente',
                            icon: 'user outline',
                        },
                        pane: <Tab.Pane key="customer">
                            <Form>
                                <Form.Group>
                                    <Form.Select
                                        search
                                        width="3"
                                        label="Ano"
                                        required
                                        name="year"
                                        onChange={fieldChange('customer')}
                                        selectOnBlur={false}
                                        options={getYears().map((year) => ({
                                            key: year,
                                            value: year,
                                            text: year,
                                        }))}
                                    />
                                    <Form.Select
                                        search
                                        width={3}
                                        required
                                        name="paymentType"
                                        label="Tipo de Recebível"
                                        onChange={fieldChange('customer')}
                                        value={filterState.customer.paymentType}
                                        selectOnBlur={false}
                                        options={paymentTypes.map((it) => ({
                                            key: it.name,
                                            value: it.name,
                                            text: it.text,
                                        }))}
                                    />
                                    <Form.Field>
                                        <label>Data de corte</label>
                                        <ReactInputMask
                                            name="cutDate"
                                            mask="99/99/9999"
                                            onChange={fieldChange('customer')}
                                            value={filterState.customer.cutDate}
                                        />
                                    </Form.Field>
                                    <Form.Field>
                                        <label>&nbsp;</label>
                                        <Button
                                            primary
                                            icon="cogs"
                                            content="Gerar"
                                            onClick={submit('customer')}
                                        />
                                    </Form.Field>
                                    <Form.Field className='pl-0'>
                                            <label>&nbsp;</label>
                                            <Button
                                                color='yellow'
                                                icon="erase"
                                                content="Limpar"
                                                onClick={clear('customer')}
                                            />
                                        </Form.Field>
                                </Form.Group>
                            </Form>
                        </Tab.Pane>,
                    },
                ]}
            />
        </div>
    );
}
export default withRouter(Filters);
